export const localStorageKey = "autoJoinCode";

export const setValue = (key: string, value: string) =>
  window.localStorage?.setItem(key, value);
export const getValue = (key: string) => window.localStorage?.getItem(key);
export const clearValue = (key: string) => window.localStorage?.removeItem(key);

export const getInitialState = () => getValue(localStorageKey) || null;
